import { checkLuhn } from './luhnNumberValidator';
/**
 * isValidCorporateIdentity
 * Function that validates if a string value is a valid corporate identity or not
 * @param value value to validate if it is a corporate identity or not
 * @returns boolean
 */
export function isValidCorporateIdentity(value) {
    if (!value) {
        return false;
    }
    let orgnum = value.replace(/[\D]/gm, '');
    if (orgnum.length === 12) {
        orgnum = orgnum.slice(-10);
    }
    const regex = /^(\d){10,12}$/;
    if (regex.test(orgnum) && checkLuhn(orgnum)) {
        return true;
    }
    return false;
}
